module.exports = __webpack_public_path__ + "img/TSGMitgliederPortalLink.a60da174.png";